import React, { createContext, useState } from 'react';

export const secundaryPagesContext = createContext();

const SecundaryPagesContext = (props) => {

    const [foundationState, setFoundationState] = useState({
        enter: false,
        active: true
    });

    const [philosophyState, setPhilosophyState] = useState({
        enter: false,
        active: false
    });

    const [departmentsState, setDepartmentsState] = useState({
        enter: false,
        active: false
    });

    const [commitmentState, setCommitmentState] = useState({
        enter: false,
        active: false
    });

     const [anthemState, setAnthemState] = useState({
        enter: false,
        active: false
    });

    const [virtualTourState, setVirtualTourState] = useState({
        enter: false,
        active: false
    });

    

    return (
        <secundaryPagesContext.Provider
            value={{
                foundationState,
                setFoundationState,
                philosophyState,
                setPhilosophyState,
                departmentsState,
                setDepartmentsState,
                commitmentState,
                setCommitmentState,
                anthemState,
                setAnthemState,
                virtualTourState,
                setVirtualTourState,
                // historyState,
                // setHistoryState,
                // alliesState,
                // setAlliesState,
                // virtualToolsState,
                // setVirtualToolsState,
            }}
        >
            {props.children}
        </secundaryPagesContext.Provider>
    );
}

export default SecundaryPagesContext;